/**
 * The host removing a player who has been away for two minutes. Two taps, like
 * leaving, because it cannot be undone. scope.md §6.4.
 */

import { useEffect, useState } from 'react';
import { ARM_MS } from './LeaveButton.js';
import { useT } from '../i18n.js';

export function KickButton({ name, onKick }: { name: string; onKick: () => void }) {
  const t = useT();
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return;
    const handle = setTimeout(() => setArmed(false), ARM_MS);
    return () => clearTimeout(handle);
  }, [armed]);

  return (
    <button
      type="button"
      data-testid="kick-button"
      data-armed={armed}
      aria-label={armed ? t('kick.confirm', { name }) : t('kick.label', { name })}
      onClick={() => (armed ? onKick() : setArmed(true))}
      className={[
        'mt-1 w-full rounded-lg px-2 text-[10px] font-bold',
        armed ? 'bg-coral text-ink' : 'bg-white/10 text-bone/80',
      ].join(' ')}
    >
      {armed ? t('common.really') : t('common.remove')}
    </button>
  );
}
